<div>
  {{ params.value | number:'1.2-2'}}
</div>